export default __webpack_public_path__ + "ae4abd8a5e4c4465d1881c1d98e2cdc6.svg";